import { TimelineMax, Expo } from 'gsap'
import SplitText from '@/assets/lib/SplitText'

const transition = (fromMenu, callback) => {
  const tl = new TimelineMax({
    delay: fromMenu ? 0.9 : 0,
    onComplete: callback
  })
  let els = Array.from(document.querySelectorAll('.title-chars'))

  if (els.length === 0) {
    const split = new SplitText(
      document.querySelector('[data-title]'),
      { type: 'words, chars', charsClass: 'title-chars' }
    )
    els = split.chars
  }

  tl
    .add('start')
    .to('[data-hero-image]', 1, {
      autoAlpha: 0,
      scale: 0.95,
      ease: Expo.easeInOut
    }, 'start')
    .staggerTo(els, 1.2, {
      yPercent: 60,
      rotationZ: 20,
      rotationY: 80,
      autoAlpha: 0,
      ease: Expo.easeInOut
    }, 0.03, 'start')
    .to('[data-arrows-hero]', 1, {
      y: 20,
      autoAlpha: 0,
      ease: Expo.easeInOut
    }, 'start')

  return tl
}

export default transition



// WEBPACK FOOTER //
// ./src/scripts/transitions/sliderOut.js